module.exports = __webpack_public_path__ + "static/img/img.f2a85b6a.png";